<template lang="pug">
  .component-selectize-vehicle
    selectize(v-if="options", :selectedValue="selectedValue", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :disabled="disabled", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Toc", @itemRemoved="optionRemoved")
</template>

<script>
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
  import BaseSelectize from './BaseSelectize'
  import Selectize from "../../../Selectize";

  export default {
    name: "SelectizeToc",
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: [
          'id',
          'name',
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.tocs.list.all((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div>T${item.id} ${item.name}</div><div><small>${item.toc_type.name}</small></div></div>`
      },
      renderTemplate(item, escape) {
        return `<div>T${item.id} ${item.name}</div>`
      },
      optionsLoader() {

      }
    },
    props: ['selectedValue']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeToc.vue?5c9e0224